module.exports = __webpack_public_path__ + "static/media/Icon awesome-facebook.a9bd1d82.svg";